import HttpService from '../baseHttp'

// 成本列表
export const HttpCostList = (data = {}, config) => HttpService.get('/api/v2/ItemCost/findCostByPage', { params: data })

// 单条查看
export const HttpGetCostOne = (data = {}, config) => HttpService.get('/api/v2/ItemCost/findCostDetail', { params: data })

// 编辑保存
export const HttpSaveCostOne = (data = {}, config) => HttpService.post('/api/v2/ItemCost/updateItemCost', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })

// 成本操作历史
export const HttpGetCostopLog = (data = {}, config) => HttpService.get('/api/v2/ItemCost/findOpLog', { params: data })



// 成本组管理列表
export const HttpCostGroupList = (data = {}, config) => HttpService.get('/api/v2/ItemCost/findWarehouseGroupByPage', { params: data })

// 成本组查看页面
export const HttpGetCostGroupOne = (data = {}, config) => HttpService.get('/api/v2/ItemCost/findWarehouseGroupById', { params: data })
// 查看仓库列表获取
export const HttpGetWarehouseList = (data = {}, config) => HttpService.get('/api/v2/ItemCost/findWarehouseByGroupAndPage', { params: data })

// 成本组新增/编辑
export const HttpSaveCostGroupOne = (data = {}, config) => HttpService.post('/api/v2/ItemCost/editWarehouseGroup', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
// 单独仓库table的增加和删除
// 增加单条
export const HttpAddWarehouseOne = (data = {}, config) => HttpService.post('/api/v2/ItemCost/addWarehouseToGroup', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
// 删除单条
export const HttpDeleteWarehouseOne = (data = {}, config) => HttpService.get('/api/v2/ItemCost/delWarehouseFromGroup', { params: data })

// 成本计算历史获取
export const HttpGetCostComputed = (data = {}, config) => HttpService.get('/api/v2/ItemCost/findCostHistoryByPage', { params: data })


// 获取成本组列表
export const HttpGetCostGroupNameList = (data = {}, config) => HttpService.get('/api/v2/ItemCost/findWarehouseGroupByOrg', { params: data })




